/**
 * @desc 更新下载时间
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/fileDownloadTaskRecord/${id}/updateDownloadTime`, {
      method: "POST",

      ...options,
    }),
  );
}
